// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"Button_buttonWrapper__vCiww","loader":"Button_loader__otVES","buttonTextHidden":"Button_buttonTextHidden__t4GT+","buttonContent":"Button_buttonContent__Z9WTA"};